import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion';
import styled from '@emotion/styled';

import { launchpadSelectors, launchpadActions } from '../reducer/launchpad-reducer';
import { exportSelectors, exportActions } from '../reducer/export-reducer';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import {
  appMainBackground,
  appTextColor,
  white,
  defaultBoxShadow,
  dashboardGray,
  borderColor,
  darkModalBackdropColor,
  blueEnabledColor
} from '../../../styles/colors';
import { appMinWidth } from '../../../styles/constants';

import learningImage_ar from '../../../assets/images/dashboard-languages/ar.png';
import learningImage_de_DE from '../../../assets/images/dashboard-languages/de-DE.png';
import learningImage_el_GR from '../../../assets/images/dashboard-languages/el-GR.png';
import learningImage_en_GB from '../../../assets/images/dashboard-languages/en-GB.png';
import learningImage_en_US from '../../../assets/images/dashboard-languages/en-US.png';
import learningImage_es_ES from '../../../assets/images/dashboard-languages/es-ES.png';
import learningImage_fa_IR from '../../../assets/images/dashboard-languages/fa-IR.png';
import learningImage_fr_FR from '../../../assets/images/dashboard-languages/fr-FR.png';
import learningImage_ga_IE from '../../../assets/images/dashboard-languages/ga-IE.png';
import learningImage_he_IL from '../../../assets/images/dashboard-languages/he-IL.png';
import learningImage_hi_IN from '../../../assets/images/dashboard-languages/hi-IN.png';
import learningImage_it_IT from '../../../assets/images/dashboard-languages/it-IT.png';
import learningImage_ja_JP from '../../../assets/images/dashboard-languages/ja-JP.png';
import learningImage_ko_KR from '../../../assets/images/dashboard-languages/ko-KR.png';
import learningImage_nl_NL from '../../../assets/images/dashboard-languages/nl-NL.png';
import learningImage_pl_PL from '../../../assets/images/dashboard-languages/pl-PL.png';
import learningImage_pt_BR from '../../../assets/images/dashboard-languages/pt-BR.png';
import learningImage_ru_RU from '../../../assets/images/dashboard-languages/ru-RU.png';
import learningImage_short_es_419 from '../../../assets/images/dashboard-languages/short_es-419.png';
import learningImage_sv_SE from '../../../assets/images/dashboard-languages/sv-SE.png';
import learningImage_tl_PH from '../../../assets/images/dashboard-languages/tl-PH.png';
import learningImage_tr_TR from '../../../assets/images/dashboard-languages/tr-TR.png';
import learningImage_vi_VN from '../../../assets/images/dashboard-languages/vi-VN.png';
import learningImage_zh_CN from '../../../assets/images/dashboard-languages/zh-CN.png';

import { appSelectors } from '../../app/reducer/app-reducer';
import { ExportReportContainer as ExportReport } from './ExportReport';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';
import { MousySpinner } from '../../app/util/MousySpinner';

const DashboardBox = styled.div(() => {});
const totalCellBg = '#F2F5F8';

const DashboardContentContainerDiv = styled.div((props) => {
  let style = {
    fontFamily: 'inherit',
    width: !props.isMobile ? '1076px' : '100%',
    padding: !props.isMobile ? '0' : '0 16px',
    fontSize: '14px',
    margin: 'auto'
  };

  return style;
});

const ActivityBox = styled.div((props) => {
  let style = {
    backgroundColor: white,
    fontFamily: 'inherit',
    padding: !props.isMobile ? '20px 372px 20px 20px' : '10px 16px',
    borderRadius: !props.isMobile ? '4px' : '6px',
    boxShadow: defaultBoxShadow,
    textAlign: 'center',
    position: 'relative',
    backgroundPosition: 'bottom right',
    backgroundRepeat: 'no-repeat'
  };
  if (props.isMobile) {
    style.backgroundImage = 'none';
    style.clear = 'both';
  } else if (props.learningImg === 'ar') {
    style.backgroundImage = 'url(' + learningImage_ar + ')';
  } else if (props.learningImg === 'de-DE') {
    style.backgroundImage = 'url(' + learningImage_de_DE + ')';
  } else if (props.learningImg === 'el-GR') {
    style.backgroundImage = 'url(' + learningImage_el_GR + ')';
  } else if (props.learningImg === 'en-GB') {
    style.backgroundImage = 'url(' + learningImage_en_GB + ')';
  } else if (props.learningImg === 'en-US') {
    style.backgroundImage = 'url(' + learningImage_en_US + ')';
  } else if (props.learningImg === 'es-ES') {
    style.backgroundImage = 'url(' + learningImage_es_ES + ')';
  } else if (props.learningImg === 'fa-IR') {
    style.backgroundImage = 'url(' + learningImage_fa_IR + ')';
  } else if (props.learningImg === 'fr-FR') {
    style.backgroundImage = 'url(' + learningImage_fr_FR + ')';
  } else if (props.learningImg === 'ga-IE') {
    style.backgroundImage = 'url(' + learningImage_ga_IE + ')';
  } else if (props.learningImg === 'he-IL') {
    style.backgroundImage = 'url(' + learningImage_he_IL + ')';
  } else if (props.learningImg === 'hi-IN') {
    style.backgroundImage = 'url(' + learningImage_hi_IN + ')';
  } else if (props.learningImg === 'it-IT') {
    style.backgroundImage = 'url(' + learningImage_it_IT + ')';
  } else if (props.learningImg === 'ja-JP') {
    style.backgroundImage = 'url(' + learningImage_ja_JP + ')';
  } else if (props.learningImg === 'ko-KR') {
    style.backgroundImage = 'url(' + learningImage_ko_KR + ')';
  } else if (props.learningImg === 'nl-NL') {
    style.backgroundImage = 'url(' + learningImage_nl_NL + ')';
  } else if (props.learningImg === 'pl-PL') {
    style.backgroundImage = 'url(' + learningImage_pl_PL + ')';
  } else if (props.learningImg === 'pt-BR') {
    style.backgroundImage = 'url(' + learningImage_pt_BR + ')';
  } else if (props.learningImg === 'ru-RU') {
    style.backgroundImage = 'url(' + learningImage_ru_RU + ')';
  } else if (props.learningImg === 'es-419') {
    style.backgroundImage = 'url(' + learningImage_short_es_419 + ')';
  } else if (props.learningImg === 'sv-SE') {
    style.backgroundImage = 'url(' + learningImage_sv_SE + ')';
  } else if (props.learningImg === 'tl-PH') {
    style.backgroundImage = 'url(' + learningImage_tl_PH + ')';
  } else if (props.learningImg === 'tr-TR') {
    style.backgroundImage = 'url(' + learningImage_tr_TR + ')';
  } else if (props.learningImg === 'vi-VN') {
    style.backgroundImage = 'url(' + learningImage_vi_VN + ')';
  } else if (props.learningImg === 'zh-CN') {
    style.backgroundImage = 'url(' + learningImage_zh_CN + ')';
  }

  return style;
});

const ActivityBoxMobileHeader = styled.div(() => {
  let style = {
    margin: '10px 16px'
  };

  return style;
});

const ActivityLabel = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '18px' : '14px',
    textAlign: 'left',
    fontWeight: '500',
    float: !props.isMobile ? 'none' : 'left',
    lineHeight: !props.isMobile ? 'auto' : '20px'
  };

  return style;
});

const ExportButton = styled(LaunchpadButton)((props) => {
  let style = {
    fontSize: !props.isMobile ? '16px' : '14px',
    lineHeight: '20px',
    width: 'auto',
    padding: '0 16px',
    ':hover': {}
  };
  if (!props.isMobile) {
    style.position = 'absolute';
    style.top = '20px';
    style.right = '372px';
    style.height = '36px';
  } else {
    style.backgroundColor = appMainBackground;
    style.padding = '0';
    style.color = blueEnabledColor;
    style.float = 'right';
    style.borderRadius = '0';
    style.height = '20px';
    style.marginBottom = '10px';
    style[':hover'].backgroundColor = appMainBackground;
  }
  return style;
});

const ActivityTable = styled.table((props) => {
  let style = {
    fontSize: '16px',
    margin: !props.isMobile ? '30px auto 10px' : '0 auto 10px',
    borderCollapse: 'collapse',
    width: '100%'
  };

  return style;
});

const ActivityTableRow = styled.tr(() => {
  let style = {};
  return style;
});

const ActivityTableHeader = styled.thead((props) => {
  let style = {};
  return style;
});

const ActivityTableHeaderCell = styled.th((props) => {
  let style = {
    padding: '12px',
    fontSize: !props.isMobile ? '14px' : '9px',
    color: dashboardGray,
    fontWeight: props.total ? '500' : 'normal',
    display: props.hideCell ? 'none' : 'table-header',
    width: '20%'
  };

  return style;
});

const ActivityTableBody = styled.tbody((props) => {
  let style = {
    marginLeft: !props.isMobile ? '50px' : '0'
  };
  return style;
});

const ActivityTableCell = styled.td((props) => {
  let style = {
    lineHeight: !props.isMobile ? '60px' : 'auto',
    fontSize: !props.isMobile ? '32px' : '18px',
    color: props.label ? dashboardGray : appTextColor,
    textAlign: 'center',
    backgroundColor: props.total ? totalCellBg : 'transparent',
    fontWeight: props.total ? 'normal' : '200',
    borderBottom: props.month ? '1px solid' + borderColor : 'none',
    borderLeft: props.tutor || props.mobile ? '1px solid' + borderColor : 'none',
    display: props.hideCell ? 'none' : 'table-cell'
  };

  return style;
});

const ActivityTableLabel = styled(ActivityTableCell)((props) => {
  let style = {
    fontSize: !props.isMobile ? '14px' : '9px',
    color: dashboardGray,
    textAlign: 'left',
    paddingRight: '20px',
    width: '126px'
  };

  return style;
});

const TriggerDiv = styled.div(() => {
  let style = {
    position: 'absolute',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    minWidth: appMinWidth,
    backgroundColor: 'transparent'
  };
  return style;
});

const ModalBackdrop = styled.div(() => {
  let style = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    display: 'block',
    backgroundColor: darkModalBackdropColor,
    overflow: 'auto',
    zIndex: '998'
  };
  return style;
});

const MousySpinnerContainer = styled.div({
  margin: '50px 45%'
});

class Dashboard extends PureComponent {
  componentDidMount = () => {
    if (this.props.isCatalyst) {
      this.props.initDashboard();
    }
  };

  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }

    const isMobile = isMobileDetected;
    let ExportReportContainer = null;
    let DashboardContentContainer = null;
    let DashboardActivityBoxMobileHeader = null;
    let DashboardActivityBoxWebHeader = null;

    if (this.props.showDashboardExportPopup) {
      ExportReportContainer = (
        <TriggerDiv data-qa="ExportWrapper">
          <ModalBackdrop />
          <ExportReport />
        </TriggerDiv>
      );
    }

    if (isMobile) {
      DashboardActivityBoxMobileHeader = (
        <ActivityBoxMobileHeader>
          <ActivityLabel isMobile={isMobile}>
            <LionTranslate lionkey="_dashboard_my_activity" />
          </ActivityLabel>
          <ExportButton onClick={() => this.props.setExportPopupView(true)} isMobile={isMobile}>
            <LionTranslate lionkey="_dashboard_export_report" />
          </ExportButton>
        </ActivityBoxMobileHeader>
      );
    } else {
      DashboardActivityBoxWebHeader = (
        <div>
          <ActivityLabel>
            <LionTranslate lionkey="_dashboard_my_activity" />
          </ActivityLabel>
          <ExportButton onClick={() => this.props.setExportPopupView(true)}>
            <LionTranslate lionkey="_dashboard_export_report" />
          </ExportButton>
        </div>
      );
    }

    if (this.props.dashboardLoading) {
      DashboardContentContainer = (
        <MousySpinnerContainer>
          <MousySpinner />
        </MousySpinnerContainer>
      );
    } else if (!this.props.dashboard.isLearner || !this.props.dashboard.showDashboard) {
      // EE-520: this.props.dashboard is empty because initDashboard was never called for endangeredLanguages
      DashboardContentContainer = null;
    } else {
      DashboardContentContainer = (
        <div>
          {DashboardActivityBoxMobileHeader}
          <DashboardContentContainerDiv isMobile={isMobile}>
            {ExportReportContainer}
            <ActivityBox learningImg={this.props.dashboard.languageOfStudy} isMobile={isMobile}>
              {DashboardActivityBoxWebHeader}
              <ActivityTable isMobile={isMobile}>
                <ActivityTableHeader>
                  <ActivityTableRow>
                    <ActivityTableHeaderCell />
                    <ActivityTableHeaderCell isMobile={isMobile}>
                      <LionTranslate lionkey="_dashboard_desktop" />
                    </ActivityTableHeaderCell>
                    <ActivityTableHeaderCell isMobile={isMobile}>
                      <LionTranslate lionkey="_dashboard_mobile" />
                    </ActivityTableHeaderCell>
                    <ActivityTableHeaderCell hideCell={!this.props.dashboard.showDashboardTutoring} isMobile={isMobile}>
                      <LionTranslate lionkey="_dashboard_tutoring" />
                    </ActivityTableHeaderCell>
                    <ActivityTableHeaderCell total isMobile={isMobile}>
                      <LionTranslate lionkey="_dashboard_total" />
                    </ActivityTableHeaderCell>
                  </ActivityTableRow>
                </ActivityTableHeader>

                <ActivityTableBody>
                  <ActivityTableRow>
                    <ActivityTableLabel isMobile={isMobile}>
                      <LionTranslate lionkey="_dashboard_this_month" />
                    </ActivityTableLabel>
                    <ActivityTableCell isMobile={isMobile} month desktop>
                      {this.props.dashboard.monthOnline}
                    </ActivityTableCell>
                    <ActivityTableCell isMobile={isMobile} month mobile>
                      {this.props.dashboard.monthMobile}
                    </ActivityTableCell>
                    <ActivityTableCell
                      isMobile={isMobile}
                      month
                      tutor
                      hideCell={!this.props.dashboard.showDashboardTutoring}
                    >
                      {this.props.dashboard.monthTutoring}
                    </ActivityTableCell>
                    <ActivityTableCell isMobile={isMobile} month total>
                      {this.props.dashboard.monthTotal}
                    </ActivityTableCell>
                  </ActivityTableRow>
                  <ActivityTableRow>
                    <ActivityTableLabel isMobile={isMobile}>
                      <LionTranslate lionkey="_dashboard_all_time" />
                    </ActivityTableLabel>
                    <ActivityTableCell isMobile={isMobile} desktop>
                      {this.props.dashboard.allTimeOnline}
                    </ActivityTableCell>
                    <ActivityTableCell isMobile={isMobile} mobile>
                      {this.props.dashboard.allTimeMobile}
                    </ActivityTableCell>
                    <ActivityTableCell isMobile={isMobile} tutor hideCell={!this.props.dashboard.showDashboardTutoring}>
                      {this.props.dashboard.allTimeTutoring}
                    </ActivityTableCell>
                    <ActivityTableCell isMobile={isMobile} total>
                      {this.props.dashboard.allTimeTotal}
                    </ActivityTableCell>
                  </ActivityTableRow>
                </ActivityTableBody>
              </ActivityTable>
            </ActivityBox>
          </DashboardContentContainerDiv>
        </div>
      );
    }
    return (
      <DashboardBox>
        <div data-qa="dashboard">{DashboardContentContainer}</div>
      </DashboardBox>
    );
  };
}

Dashboard.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  getLionTranslatedString: (key, placeholders, values, altLocale) =>
    lionSelectors.getLionTranslatedString(state, key, placeholders, values, altLocale),
  dashboard: launchpadSelectors.dashboard(state),
  dashboardLoading: launchpadSelectors.dashboardLoading(state),
  showDashboardExportPopup: exportSelectors.showDashboardExportPopup(state)
});

const wrapActions = {
  setExportPopupView: exportActions.setExportPopupView,
  initDashboard: launchpadActions.initDashboard
};

export const DashboardContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(Dashboard));



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/DashboardReport.jsx